const dpdParcelshopShippingMethod = (function () {
	const SHIPPING_TYPE_FIXED = 'fixed';
	const SHIPPING_TYPE_PRODUCTS_WEIGHT_BASED = 'products_weight_based';

	let shippingTypeSelect,
		fixedShippingTypes,
		productsWeightBasedShippingTypes,
		productsWeightLimitCheckbox,
		productsWeightLimitShippingFields,
		productsDimensionLimitCheckbox,
		productsDimensionLimitShippingFields;

	function init() {
		// Shipping type fields
		shippingTypeSelect = document.querySelector('.js-dpd-shipping-type-select');

		if (shippingTypeSelect) {
			fixedShippingTypes = document.querySelectorAll(
				'.js-dpd-fixed-shipping-type'
			);
			productsWeightBasedShippingTypes = document.querySelectorAll(
				'.js-dpd-weight-based-shipping-type'
			);

			shippingTypeSelect.addEventListener('change', updateShippingTypeFields);
			updateShippingTypeFields();
		}

		// Products weight limit fields
		productsWeightLimitCheckbox = document.querySelector(
			'.js-dpd-checkbox-weight-limit'
		);

		if (productsWeightLimitCheckbox) {
			productsWeightLimitShippingFields = document.querySelectorAll(
				'.js-dpd-weight-limit-shipping-type'
			);

			productsWeightLimitCheckbox.addEventListener(
				'change',
				updateProductWeightLimitFields
			);
			updateProductWeightLimitFields();
		}

		// Products dimension limit fields
		productsDimensionLimitCheckbox = document.querySelector(
			'.js-dpd-checkbox-dimension-limit'
		);

		if (productsDimensionLimitCheckbox) {
			productsDimensionLimitShippingFields = document.querySelectorAll(
				'.js-dpd-dimension-limit-shipping-type'
			);

			productsDimensionLimitCheckbox.addEventListener(
				'change',
				updateProductDimensionLimitFields
			);
			updateProductDimensionLimitFields();
		}
	}

	function updateShippingTypeFields() {
		const isFixed = shippingTypeSelect.value === SHIPPING_TYPE_FIXED;
		toggleElements(fixedShippingTypes, isFixed);
		toggleElements(productsWeightBasedShippingTypes, !isFixed);
	}

	function updateProductWeightLimitFields() {
		toggleElements(
			productsWeightLimitShippingFields,
			productsWeightLimitCheckbox.checked
		);
	}

	function updateProductDimensionLimitFields() {
		toggleElements(
			productsDimensionLimitShippingFields,
			productsDimensionLimitCheckbox.checked
		);
	}

	function toggleElements(elements, show) {
		elements.forEach((el) => {
			const parentFieldset = el.closest('fieldset');
			if (parentFieldset) {
				const label = parentFieldset.previousElementSibling;
				if (label && label.tagName === 'LABEL') {
					label.style.display = show ? '' : 'none';
				}
				parentFieldset.style.display = show ? '' : 'none';
			}
		});
	}

	return {
		init: init,
	};
})();

export default dpdParcelshopShippingMethod;
